module.exports = __webpack_public_path__ + "img/FAV_0059.1f0043ca.jpg";